import React, { useState } from 'react';
import { ProTask } from '../types';
import { StatusBadge } from '../components/StatusBadge';
import { PriorityBadge } from '../components/PriorityBadge';
import { SummaryCard } from '../components/SummaryCard';
import { MegaphoneIcon, SearchIcon, PlusIcon, ActivityIcon, CheckCircleIcon, ClockIcon, UsersIcon, Share2Icon } from 'lucide-react';
interface ProPageProps {
  tasks: ProTask[];
}
export function ProPage({
  tasks
}: ProPageProps) {
  const [searchTerm, setSearchTerm] = useState('');
  const [statusFilter, setStatusFilter] = useState('Semua Status');
  const [priorityFilter, setPriorityFilter] = useState('Semua Prioritas');
  const filteredTasks = tasks.filter(task => {
    const matchSearch = task.title.toLowerCase().includes(searchTerm.toLowerCase()) || task.code.toLowerCase().includes(searchTerm.toLowerCase()) || task.narrativeAngle.toLowerCase().includes(searchTerm.toLowerCase());
    const matchStatus = statusFilter === 'Semua Status' || task.status === statusFilter;
    const matchPriority = priorityFilter === 'Semua Prioritas' || task.priority === priorityFilter;
    return matchSearch && matchStatus && matchPriority;
  });
  // Stats
  const activeCount = tasks.filter(t => t.status === 'Berjalan').length;
  const plannedCount = tasks.filter(t => t.status === 'Direncanakan').length;
  const completedCount = tasks.filter(t => t.status === 'Selesai').length;
  const totalTargetReach = tasks.reduce((acc, curr) => acc + curr.targetReach, 0);
  const totalAchievedReach = tasks.reduce((acc, curr) => acc + curr.achievedReach, 0);
  const handleAdd = () => alert('Fitur tambah tugas PRO akan tersedia pada versi berikutnya.');
  const handleView = (id: string) => alert(`Membuka detail tugas PRO: ${id}`);
  return <div className="space-y-6 flex flex-col h-full" data-id="element-904">
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4" data-id="element-905">
        <h2 className="text-2xl font-bold text-[#E2E8F0] uppercase tracking-wide flex items-center" data-id="element-906">
          <MegaphoneIcon className="w-6 h-6 mr-3 text-[#00D4FF]" data-id="element-907" />
          OPERASI AMPLIFIKASI (PRO)
        </h2>
        <button onClick={handleAdd} className="flex items-center px-4 py-2 bg-[#00D4FF] text-[#0B0F1A] rounded hover:bg-[#00D4FF]/90 transition-colors shadow-sm font-bold text-sm uppercase glow-cyan" data-id="element-908">
          <PlusIcon className="w-4 h-4 mr-2" data-id="element-909" />
          TAMBAH TUGAS
        </button>
      </div>

      {/* Summary Cards */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-910">
        <SummaryCard title="Tugas Berjalan" value={activeCount} icon={<ActivityIcon className="w-6 h-6" data-id="element-912" />} iconBgColor="bg-[#00D4FF]/10" iconColor="text-[#00D4FF]" borderColor="border-t-[#00D4FF]" data-id="element-911" />
        <SummaryCard title="Direncanakan" value={plannedCount} icon={<ClockIcon className="w-6 h-6" data-id="element-914" />} iconBgColor="bg-[#A855F7]/10" iconColor="text-[#A855F7]" borderColor="border-t-[#A855F7]" data-id="element-913" />
        <SummaryCard title="Total Target Reach" value={totalTargetReach.toLocaleString('id-ID')} icon={<UsersIcon className="w-6 h-6" data-id="element-916" />} iconBgColor="bg-[#FFB800]/10" iconColor="text-[#FFB800]" borderColor="border-t-[#FFB800]" data-id="element-915" />
        <SummaryCard title="Total Achieved Reach" value={totalAchievedReach.toLocaleString('id-ID')} icon={<CheckCircleIcon className="w-6 h-6" data-id="element-918" />} iconBgColor="bg-[#00FF88]/10" iconColor="text-[#00FF88]" borderColor="border-t-[#00FF88]" data-id="element-917" />
      </div>

      {/* Filters */}
      <div className="bg-[#111827] p-4 rounded shadow-sm border border-[#1E3A5F] flex flex-wrap gap-4 items-center" data-id="element-919">
        <div className="relative flex-1 min-w-[200px]" data-id="element-920">
          <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-921">
            <SearchIcon className="h-4 w-4 text-[#94A3B8]" data-id="element-922" />
          </div>
          <input type="text" placeholder="Cari kode, judul, atau narasi..." value={searchTerm} onChange={e => setSearchTerm(e.target.value)} className="block w-full pl-10 pr-3 py-2 border border-[#1E3A5F] rounded text-sm focus:ring-1 focus:ring-[#00D4FF] focus:border-[#00D4FF] bg-[#0B0F1A] text-[#E2E8F0] placeholder-[#475569]" data-id="element-923" />
        </div>

        <select value={statusFilter} onChange={e => setStatusFilter(e.target.value)} className="border border-[#1E3A5F] rounded text-sm py-2 pl-3 pr-8 focus:ring-1 focus:ring-[#00D4FF] focus:border-[#00D4FF] bg-[#0B0F1A] text-[#E2E8F0]" data-id="element-924">
          <option value="Semua Status" data-id="element-925">Semua Status</option>
          <option value="Draft" data-id="element-926">Draft</option>
          <option value="Direncanakan" data-id="element-927">Direncanakan</option>
          <option value="Berjalan" data-id="element-928">Berjalan</option>
          <option value="Selesai" data-id="element-929">Selesai</option>
          <option value="Dibatalkan" data-id="element-930">Dibatalkan</option>
        </select>

        <select value={priorityFilter} onChange={e => setPriorityFilter(e.target.value)} className="border border-[#1E3A5F] rounded text-sm py-2 pl-3 pr-8 focus:ring-1 focus:ring-[#00D4FF] focus:border-[#00D4FF] bg-[#0B0F1A] text-[#E2E8F0]" data-id="element-931">
          <option value="Semua Prioritas" data-id="element-932">Semua Prioritas</option>
          <option value="Rendah" data-id="element-933">Rendah</option>
          <option value="Sedang" data-id="element-934">Sedang</option>
          <option value="Tinggi" data-id="element-935">Tinggi</option>
          <option value="Sangat Tinggi" data-id="element-936">Sangat Tinggi</option>
        </select>
      </div>

      {/* Task List */}
      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6" data-id="element-937">
        {filteredTasks.length > 0 ? filteredTasks.map(task => <div key={task.id} className="bg-[#111827] border border-[#1E3A5F] rounded-lg p-5 hover:border-[#00D4FF]/50 transition-colors shadow-lg flex flex-col group cursor-pointer" onClick={() => handleView(task.id)} data-id="element-938">
              <div className="flex justify-between items-start mb-3" data-id="element-939">
                <span className="text-xs font-mono text-[#00D4FF] bg-[#00D4FF]/10 px-2 py-1 rounded" data-id="element-940">
                  {task.code}
                </span>
                <StatusBadge status={task.status as any} data-id="element-941" />
              </div>
              <h3 className="text-lg font-bold text-[#E2E8F0] mb-2 line-clamp-2 group-hover:text-[#00D4FF] transition-colors" data-id="element-942">
                {task.title}
              </h3>
              <p className="text-sm text-[#94A3B8] mb-4 line-clamp-2 flex-1" data-id="element-943">
                {task.description}
              </p>

              <div className="space-y-2 mb-4" data-id="element-944">
                <div className="flex justify-between text-xs" data-id="element-945">
                  <span className="text-[#64748B]" data-id="element-946">Platform:</span>
                  <span className="text-[#E2E8F0] font-medium" data-id="element-947">
                    {task.platform}
                  </span>
                </div>
                <div className="flex justify-between text-xs" data-id="element-948">
                  <span className="text-[#64748B]" data-id="element-949">Tipe Konten:</span>
                  <span className="text-[#E2E8F0] font-medium" data-id="element-950">
                    {task.contentType}
                  </span>
                </div>
                <div className="flex justify-between text-xs" data-id="element-951">
                  <span className="text-[#64748B]" data-id="element-952">Narasi:</span>
                  <span className="text-[#E2E8F0] font-medium truncate max-w-[150px]" data-id="element-953">
                    {task.narrativeAngle}
                  </span>
                </div>
              </div>

              <div className="mb-4" data-id="element-954">
                <div className="flex justify-between text-xs mb-1" data-id="element-955">
                  <span className="text-[#64748B]" data-id="element-956">Reach Progress</span>
                  <span className="text-[#00D4FF] font-bold" data-id="element-957">
                    {Math.round(task.achievedReach / task.targetReach * 100) || 0}
                    %
                  </span>
                </div>
                <div className="w-full bg-[#0B0F1A] rounded-full h-1.5 overflow-hidden border border-[#1E3A5F]" data-id="element-958">
                  <div className="bg-[#00D4FF] h-1.5 rounded-full glow-cyan" style={{
              width: `${Math.min(100, Math.round(task.achievedReach / task.targetReach * 100) || 0)}%`
            }} data-id="element-959"></div>
                </div>
                <div className="flex justify-between text-[10px] text-[#64748B] mt-1" data-id="element-960">
                  <span data-id="element-961">{task.achievedReach.toLocaleString('id-ID')}</span>
                  <span data-id="element-962">
                    Target: {task.targetReach.toLocaleString('id-ID')}
                  </span>
                </div>
              </div>

              <div className="pt-4 border-t border-[#1E3A5F] flex justify-between items-center mt-auto" data-id="element-963">
                <PriorityBadge priority={task.priority} data-id="element-964" />
                <div className="text-xs text-[#94A3B8] flex items-center" data-id="element-965">
                  <Share2Icon className="w-3 h-3 mr-1" data-id="element-966" />
                  {task.personInCharge}
                </div>
              </div>
            </div>) : <div className="col-span-full py-12 text-center bg-[#111827] border border-[#1E3A5F] rounded" data-id="element-967">
            <MegaphoneIcon className="w-12 h-12 text-[#1E3A5F] mx-auto mb-3" data-id="element-968" />
            <p className="text-[#94A3B8]" data-id="element-969">
              Tidak ada tugas PRO yang ditemukan.
            </p>
          </div>}
      </div>
    </div>;
}